import VehicleCard from "@/components/VehicleCard";
import Link from "next/link";

type Props = {
  state: string;
  type: string;
  otherVehicleData: any;
  similarData: any;
};

const OtherVehiclesSection = ({
  state,
  type,
  otherVehicleData,
  similarData,
}: Props) => {
  const lowerCaseState = state.toLowerCase();
  return (
    <div className="w-full px-4 md:px-0 pt-4">
      {state != undefined &&
        state != "" &&
        Array.isArray(otherVehicleData) &&
        otherVehicleData.length > 0 && (
          <section className="w-full">
            <p className="text-xl sm:text-3xl font-bold">
              Other vehicles for sale in {state}
            </p>
            <div className="text-lg sm:text-xl text-[#323232] font-semibold py-3">
              Check out these&nbsp;
              <Link className="underline" href={`/buy/${lowerCaseState}`}>
                private-party used cars for sale in {state}!
              </Link>
            </div>
            <div className="w-full px-2 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 md:gap-10 py-4">
              {Array.isArray(otherVehicleData)
                ? otherVehicleData.map((item: any, index: number) => {
                    return (
                      <div key={index} className="col-span-1 w-full h-full">
                        <VehicleCard data={item} index={index} key={index} />
                      </div>
                    );
                  })
                : ""}
            </div>
          </section>
        )}
      {type != undefined &&
        type != "" &&
        Array.isArray(similarData) &&
        similarData.length > 0 && (
          <section className="w-full pt-8">
            <p className="text-xl sm:text-3xl font-bold pb-4">
              Other {type} for sale
            </p>
            <div className="w-full px-2 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 md:gap-10 py-4">
              {Array.isArray(similarData)
                ? similarData.map((item: any, index: number) => {
                    return (
                      <div key={index} className="col-span-1 w-full h-full">
                        <VehicleCard data={item} index={index} />
                      </div>
                    );
                  })
                : ""}
            </div>
          </section>
        )}
    </div>
  );
};

export default OtherVehiclesSection;
